import {useState, useCallback} from 'react';

type BooleanHook = [boolean, () => void, () => void];

const useBoolean = (initialValue: boolean = false): BooleanHook => {
    const [value, setValue] = useState(initialValue);
    const on = useCallback(() => setValue(true), []);
    const off = useCallback(() => setValue(false), []);

    return [value, on, off];
};

export default useBoolean;
